
export const BASE_URL = process.env.REACT_APP_API_DOMAIN;
export const APP_ENV = process.env.REACT_APP_APP_ENV;
export const hash = process.env.REACT_APP_HASH